import Divider from '@components/V3/Divider'
import Text from '@components/V3/Text'
import TextSkeleton from '@components/V3/Text/TextSkeleton'
import getFirstTime from '@page-components/TrackV2/helpers/getFirstTime'
import isScheduledAndPending from '@page-components/TrackV2/helpers/isScheduledAndConfirming'
import useOrder from '@page-components/TrackV2/hooks/useOrder.main'
import useStatus from '@page-components/TrackV2/hooks/useStatus'
import {useTranslation} from 'next-i18next'
import {FaClock} from 'react-icons/fa'
import ReactMarkdown from 'react-markdown'

export const ScheduleSkeleton = () => (
  <>
    <Divider full className="mb-4" />
    <div className="flex items-center space-x-2">
      <FaClock size={20} />
      <div className="flex-1">
        <TextSkeleton type="body" className="w-4/5" />
        <TextSkeleton type="caption" className="w-3/5" />
      </div>
    </div>
  </>
)

export default function Schedule() {
  const {order} = useOrder()
  const status = useStatus()
  const {t} = useTranslation('tracking', {keyPrefix: 'schedule'})
  if (['done', 'cancelled', 'archived', 'readyForPickup'].includes(status)) {
    return null
  }

  return (
    <>
      <Divider full className="mb-4" />
      <div className="flex items-center space-x-2">
        <FaClock size={20} />
        <div className="flex-1">
          {isScheduledAndPending(status, order) ? (
            <>
              <Text type="caption">
                <ReactMarkdown>{t('scheduled.title')}</ReactMarkdown>
              </Text>
              <Text type="title">{order.timeText}</Text>
            </>
          ) : (
            <>
              <Text type="body">
                <ReactMarkdown>{t('estimatedDelivery', {time: order.timeText})}</ReactMarkdown>
              </Text>
              <Text type="caption">
                {t(`caption.${order.deliveryType}`, {
                  time: getFirstTime(order.timeText),
                })}
              </Text>
            </>
          )}
        </div>
      </div>
    </>
  )
}
